<template>
  <svg
    fill="CurrentColor"
    class="icon-tik"
    width="15"
    height="15"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3525 0L9.8975 17.2601L3.125 9.52569L0 13.0971L10.415 25L25 3.57143L21.3525 0Z"
    />
  </svg>
</template>
 